module.exports = __webpack_public_path__ + "img/f69.ef36cb4d.png";